import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AddRecipePage from './pages/AddRecipePage';
import RecipesPage from './pages/RecipesPage';
import WorldRecipesPage from './pages/WorldRecipesPage';
import RecipeDetailPage from './pages/RecipeDetailPage';
import EditRecipePage from './pages/EditRecipePage';
import { RecipeProvider } from './contexts/RecipeContext';
import './index.css';

function App() {
  // Initialisation des animations AOS
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false,
      mirror: true,
      offset: 100,
    });
  }, []);

  return (
    <RecipeProvider>
      <Router>
        <div className="App font-poppins">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/add-recipe" element={<AddRecipePage />} />
            <Route path="/recipes" element={<RecipesPage />} />
            <Route path="/world-recipes" element={<WorldRecipesPage />} />
            <Route path="/recipe/:id" element={<RecipeDetailPage />} />
            <Route path="/edit-recipe/:id" element={<EditRecipePage />} />
          </Routes>
        </div>
      </Router>
    </RecipeProvider>
  );
}

export default App;
